import React, { Suspense, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';
import { useToolbar } from '@features/toolbar/store/hooks';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

const EncounterViewV2 = lazyWithRetry(() => import('./components/v2/EncounterViewV2'));

/**
 * Permanent entry point for viewing and editing encounters.
 */
export const EncounterPage: React.FC = () => {
  const { encounterId } = useParams<{ encounterId: string }>();
  const { setContext, show: showToolbar, hide: hideToolbar } = useToolbar();

  useEffect(() => {
    showToolbar();
    setContext({ encounterId, source: 'encounter' });

    return () => {
      hideToolbar();
      setContext(undefined);
    };
  }, [encounterId, hideToolbar, setContext, showToolbar]);

  return (
    <Suspense fallback={<CenteredSpinner />}>
      <EncounterViewV2 />
    </Suspense>
  );
};

export default EncounterPage;
